export const environment = {
  production: false,
  apiUrl: 'https://newopenspace.pyxis.com.uy',
  clientId:'e3f61c15-ad0c-4989-8634-a01b3778c7a6',
  authority: 'https://login.microsoftonline.com/1293ca30-7286-4f21-a456-0abbe06600e6/',
  redirectUrl: 'https://newopenspace.pyxis.com.uy:443',
  logoutUrl: 'https://newopenspace.pyxis.com.uy:443',
  roleAdmin: 'FullAccess',
  roleUser: 'ReadOnly'
};
